import { EventSchema } from '../../interfaces/EventInterfaces';
import { EVENT_NAME as EN } from '../../constants/EventName';
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey';
import { CommonEventProperties } from '../../utils/CommonParams';

export const ProductAddedToCartEventSchema: EventSchema = {
    eventName: EN.PRODUCT_ADDED_TO_CART,
    params: {
        ...CommonEventProperties,
        BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
        EVENT_CATEGORY: EPK.EVENT_CATEGORY,
        FULFILMENT_CHANNEL: EPK.FULFILMENT_CHANNEL,
        CHECKOUT_FLOW: EPK.CHECKOUT_FLOW,
        PRODUCTS : EPK.PRODUCTS,
        INDEX: EPK.INDEX,
        EVENT_TYPE: EPK.EVENT_TYPE,
        EVENT_SUBTYPE: EPK.EVENT_SUBTYPE,
        QUERY_ID: EPK.QUERY_ID,
    }
}